export var selectFooterState = function selectFooterState(state) {
  return state.data;
};
export var selectUserAuth = function selectUserAuth(state) {
  if (!state) {
    return undefined;
  }
  return selectFooterState(state).auth;
};
export var selectLinksBlocksLinks = function selectLinksBlocksLinks(state) {
  var _selectFooterState$li;
  return (_selectFooterState$li = selectFooterState(state).linksBlock) === null || _selectFooterState$li === void 0 ? void 0 : _selectFooterState$li.links;
};
export var selectSubscriptionBlock = function selectSubscriptionBlock(state) {
  return selectFooterState(state).subscriptionBlock;
};
export var selectAppBlock = function selectAppBlock(state) {
  return selectFooterState(state).appBlock;
};